module.exports = __webpack_public_path__ + "img/calendar-light.b647d385.svg";